<script setup>
import { ref, onMounted } from "vue";
//import Conf from '@/Components/MainGlobal.vue';
import SeoMeta from '@/Components/SeoMeta.vue';
import CardBoxModal from "@/Components/CardBoxModal.vue";
import BreezeInput from '@/Components/Input.vue';
import BreezeLabel from '@/Components/Label.vue';
import BreezeCheckbox from '@/Components/Checkbox.vue';
import { Head, Link, useForm } from '@inertiajs/inertia-vue3';
//import BreezeApplicationLogo from '@/Components/ApplicationLogo.vue';
import BreezeApplicationLogoFull from '@/Components/ApplicationLogoFull.vue';
import BreezeDropdown from '@/Components/Dropdown.vue';
import BreezeDropdownLink from '@/Components/DropdownLink.vue';

import BaseButton from "@/Components/BaseButton.vue";
import Footer from '@/Components/Footer.vue';
import { Inertia } from '@inertiajs/inertia';
import BreezeGuestLayout from '@/Layouts/Guest.vue';
import { Splide, SplideSlide, SplideTrack } from '@splidejs/vue-splide';
import { defineComponent } from 'vue';
//import { GoogleMap, Marker } from "vue3-google-map";
import { GoogleMap, Marker, MarkerCluster} from "vue3-google-map";
import helpers from '@/Common/helpers';
import '@splidejs/vue-splide/css';

import BaseIcon from "@/Components/BaseIcon.vue";
import {
    mdiArrowRight,
    mdiPhone,
    mdiEmail,
    mdiMapMarker,
    mdiCheckCircle,
    mdiCloseCircle,
    mdiSend,
    mdiLoading

} from "@mdi/js";

const props = defineProps({
    canLogin: Boolean,
    canRegister: Boolean,
    laravelVersion: String,
    phpVersion: String,
    appVersion: String,
    contentWelcome: String,
    accessStudents: Boolean,
    accessParents: Boolean,
    object: Object,
    tallas: Array,
    categoryChild: Object,
    categoryParent: Object,
    //connstantes: Array

})



// LRR
//const confGlobal = props.connstantes
/*const confGlobal = ref([])
onMounted(() => {
  let url = '/constante/global';
  axios.get(url).then(function (response) {
      var respuesta = response.data;
      confGlobal.value = respuesta.constantes;
      //console.log(me.constante);
    }).catch(function (error) {
        console.log(error);
  });
});
*/
//console.log( props.connstantes )

const isModalActive = ref(false);

const stocklabel = ref(false)

onMounted(() => {
    validNumber()
});

// Valid
const nValid1 = ref(0)
const nValid2 = ref(0)
const resultHuman = ref('')
const resultvalid = ref(0)
const validNumber = () => {
    nValid1.value = Math.ceil(Math.random() * 10)
    nValid2.value = Math.ceil(Math.random() * 10)
    resultvalid.value = parseInt(nValid1.value) + parseInt(nValid2.value)
}

/* const form = useForm({
    email: '',
    nombre: '',
    phone: '',
    comment: '',
    recibirinfo: false
}); */

const form = ref({
    name: '',
    email: '',
    phone_mobile: '',
    note: ''
})

const messagesuccess = ref('')
const messagedanger = ref('')
const submitting = ref(false)
const sendMessage = async () => {
    //let ruta = 'eco-orderregistrar' // route(ruta)
    let url = '/ecommerce/sendmessage';
    submitting.value = true

    await axios.post(url, form.value).then((response) => {
        let resp = response.data
        if (resp.success) {
            messagesuccess.value = resp.message
        } else {
            messagedanger.value = resp.message
        }
        //showAlert('Registro Creado', 'success')
        //listarPostit()
        console.log('Mensaje enviado');
        console.log(response);
    }).catch((error) => {
        //showAlert('Registro actualizado', 'danger', 5)
        console.log(error.response)
        if (error.response.data) {
            let msg = error.response.data.message
            let poscut = msg.indexOf("(and") // cortar (and 2 more errors)
            let msgerror = msg.substr(0, poscut)
            if (poscut) {
                messagedanger.value = msgerror
            } else {
                messagedanger.value = msg
            }
            
        }   
        
    });
    submitting.value = false
}

// Información de Slide, limite x 4

const slidePrincipal = ref(null)
slidePrincipal.value = [
    { 'id': '01', 'label': 'Vr Box 3D Glass', 'referencia_producto': 'Explora nuestra colección tecnológica', 'ruta_imagen': '/img/slide/slide-1.png' },
    { 'id': '02', 'label': 'Vr Box 3D Glass', 'referencia_producto': 'Explora nuestra colección tecnológica', 'ruta_imagen': '/img/slide/slide-2.png' },
    { 'id': '03', 'label': 'Vr Box 3D Glass', 'referencia_producto': 'Explora nuestra colección tecnológica', 'ruta_imagen': '/img/slide/slide-3.png' },
]

//produtos nuevos ORDER BY created_at LIMIT 8
const productosNuevos = ref(null)
productosNuevos.value = [
    { 'id': '28', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/01.jpg' },
    { 'id': '27', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 0, 'rating': 1, 'stock': '0', 'ruta_imagen': '/img/productos/02.jpg' },
    { 'id': '26', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 0, 'stock': '2', 'ruta_imagen': '/img/productos/03.jpg' },
    { 'id': '25', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/04.jpg' },
    { 'id': '24', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '1', 'ruta_imagen': '/img/productos/05.jpg' },
    { 'id': '23', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/06.jpg' },
    { 'id': '22', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/07.jpg' },
    { 'id': '21', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/08.jpg' }
]

const productosDestacados = ref(null)
productosDestacados.value = [
    { 'id': '31', 'label': 'Monitor Curvo Samsung 49″ WQLED LS49A950', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/20.jpg' },
    { 'id': '32', 'label': 'Tablet Samsung Galaxy Tab S7 Fe 64gb', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/21.jpg' },
    { 'id': '33', 'label': 'Asus ROG Strix RX5700 XT O8G 8GB', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/22.jpg' },
    { 'id': '34', 'label': 'Impresora HP LaserJet 107W', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/23.jpg' },
    { 'id': '35', 'label': 'Impresora Multifuncional Epson EcoTank L3110', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/24.jpg' },
    { 'id': '36', 'label': 'Mochila Lenovo Thinkpad Professional G2', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/25.jpg' }
]

const marcasRelacionadas = ref(null)
marcasRelacionadas.value = [
    { 'id': '101', 'ruta_imagen': '/img/marcas/01.png' },
    { 'id': '102', 'ruta_imagen': '/img/marcas/02.png' },
    { 'id': '103', 'ruta_imagen': '/img/marcas/03.png' },
    { 'id': '104', 'ruta_imagen': '/img/marcas/04.png' },
    { 'id': '105', 'ruta_imagen': '/img/marcas/05.png' },
    { 'id': '106', 'ruta_imagen': '/img/marcas/06.png' },
    { 'id': '107', 'ruta_imagen': '/img/marcas/07.png' },
    { 'id': '108', 'ruta_imagen': '/img/marcas/08.png' },
    { 'id': '109', 'ruta_imagen': '/img/marcas/09.png' },
    { 'id': '110', 'ruta_imagen': '/img/marcas/10.png' },
    { 'id': '111', 'ruta_imagen': '/img/marcas/11.png' },
    { 'id': '112', 'ruta_imagen': '/img/marcas/12.png' }
]

// Google maps
const YOUR_GOOGLE_MAPS_API_KEY = ref('AIzaSyCsT0Kr6WvAxXhz60S6i5BOguepFaeoUtg')
const center = ref({ lat: -11.992628, lng: -77.071254 })
const locations = ref([
    { lat: -11.992628, lng: -77.071254 }
])

</script>

<!-- <script>

import { GoogleMap, Marker } from "vue3-google-map";

const YOUR_GOOGLE_MAPS_API_KEY = "AIzaSyCsT0Kr6WvAxXhz60S6i5BOguepFaeoUtg";

export default {
  name: "App",
  components: { GoogleMap, Marker },
  data() {
    const center = { lat: 40.689247, lng: -111.044502 };
    return { center, YOUR_GOOGLE_MAPS_API_KEY };
  },
};

</script> -->






<!-- <script>
import { Splide, SplideSlide } from '@splidejs/vue-splide';


export default defineComponent({
    name: 'ThumbnailsExample',

    components: {
        Splide,
        SplideSlide,
    },

    setup() {
        
        const slides = generateSlides();


        onMounted(() => {
            const thumbsSplide = thumbs.value?.splide;

            if (thumbsSplide) {
                main.value?.sync(thumbsSplide);
            }
        });

        return {
            slides,
            main,
            thumbs,
            mainOptions,
            thumbsOptions,
        }
    },
});

</script> -->



<template>
    <SeoMeta />
    <BreezeGuestLayout :categoryChild="categoryChild" :categoryParent="categoryParent">


        <!-- START AREA DE TITULO -->
        <!-- START AREA DE TITULO -->
        <!-- START AREA DE TITULO -->

        <section>
            <div class="w-full h-[250px ] relative">
                <div aria-hidden="true" class="px-4 sm:px-6 lg:px-8 py-10 lg:py-20 inset-0 absolute bg-[url('/img/empresa/contacto/header.jpg')] bg-no-repeat bg-center bg-cover">
                </div>
                <div class="px-4 sm:px-6 lg:px-8 py-10 lg:py-20 absolute inset-0 bg-black bg-opacity-50">
                </div>
                <div class=" mx-auto px-4 sm:px-6 lg:px-8 py-10 lg:py-20">
                    <div class="relative flex flex-col lg:flex-row lg:justify-between items-center">
                        <div>
                            <h1 class="text-2xl lg:text-3xl text-white">Área de Contacto</h1>
                        </div>
                        <div>
                            <p class="text-xs lg:text-sm text-white font-semibold">Inicio / <span class="text-xs lg:text-sm font-normal">Contacto</span></p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- END AREA DE TITULO -->
        <!-- END AREA DE TITULO -->
        <!-- END AREA DE TITULO -->

        <!-- START AREA DE CONTACTO -->
        <!-- START AREA DE CONTACTO -->
        <!-- START AREA DE CONTACTO -->

        <section>
            <div class=" mx-auto px-4 sm:px-6 lg:px-8 py-8 lg:pt-16">
                <div class="grid grid-cols-1 lg:grid-cols-2 gap-16">
                    <div class="col-span-1">
                        <div class="mb-6">
                            <h1 class="text-2xl lg:text-3xl font-bold mb-2">Escribanos ahora</h1>
                            <p class="text-sm">Rellena el siguiente formulario o escríbenos. Te ayudaremos lo antes posible.</p>
                        </div>
                        <form>
                            <div class="grid grid-cols-1 gap-5">
                                <div>
                                    <input type="text" v-model="form.name" class="w-full" placeholder="Escriba su Nombre" required name="name">
                                </div>
                                <div>
                                    <input type="email" v-model="form.email" class="w-full" placeholder="Correo electronico" required name="email">
                                </div>
                                <div>
                                    <input type="text" v-model="form.phone_mobile" class="w-full" placeholder="Numero de Telefono" required name="phone">
                                </div>
                                <div>
                                    <textarea v-model="form.note" placeholder="Escribanos su mensaje aqui." class="w-full" rows="5"></textarea>
                                </div>

                                <!-- Valid -->
                                <div>
                                    <div v-if="!messagesuccess" class="inline-flex p-4 rounded-md items-center space-x-3 border-2 transition-all duration-300 ease-in-out bg-cover bg-center" :class="(resultHuman == resultvalid ? 'bg-green-50 border-green-600 bg-[url(/img/captcha-2.svg)]' : 'border-gray-400  hover:!border-gray-600 bg-white bg-[url(/img/captcha-1.svg)]')">
                                        <div class="text-xs mr-2 lg:mr-4 font-extrabold"><span style="text-shadow: -2px 0 #ffffff, 0 2px #ffffff, 2px 0 #ffffff, 0 -2px #ffffff">Por su seguridad<br>resuelva esta operación.</span></div>
                                        <div class="flex flex-wrap items-center text-2xl lg:text-3xl">
                                            <div class="!font-['Rubik_Dirt']">{{ nValid1 }} + {{ nValid2 }} =</div>
                                            <input type="text" v-model="resultHuman" class="w-12 ml-2 !focus:ring-0 text-center" required>
                                        </div>
                                    </div>
                                </div>

                                <!-- Alert -->
                                <div v-if="messagesuccess" class=" bg-green-50 border-green-600 text-sm px-3 py-2 border justify-left rounded-md flex items-center space-x-3">
                                    <BaseIcon :path="mdiCheckCircle" :size="24" w="w-4" h="h-4" class="text-green-600"></BaseIcon> <span class=" text-green-600">{{ messagesuccess }}</span>
                                </div>
                                <div v-if="messagedanger && !messagesuccess" class=" bg-red-50 border-red-600 text-sm px-3 py-2 border justify-left rounded-md flex items-center space-x-3">
                                    <BaseIcon :path="mdiCloseCircle" :size="24" w="w-4" h="h-4" class="text-red-600"></BaseIcon><span class=" text-red-600">{{ messagedanger }}</span>
                                </div>

                                <div>
                                    <button v-if="!messagesuccess" type="button" @click="sendMessage()" class="btn btn-color px-8 space-x-3 flex items-center" :disabled="(submitting || resultHuman != resultvalid)" :class="(resultHuman != resultvalid ? 'cursor-none opacity-50 hover:!bg-sky-500 focus-!ring-0' : '')">
                                        <BaseIcon :path="(submitting ? mdiLoading : mdiSend)" :size="24" w="w-4" h="h-4" class="text-white" :class="(submitting ?'animate-spin': '')"></BaseIcon>
                                        <span>Enviar Mensaje</span></button>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="col-span-1">
                        <h1 class="text-xl font-semibold mb-6">Información de Contacto</h1>
                        <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
                            <div class="col-span-1">
                                <div class="flex flex-row lg:flex-col justify-center border border-gray-200 p-5 rounded-lg shadow-xl shadow-gray-400/10">
                                    <div class="flex justify-center lg:mb-3">
                                        <BaseIcon :path="mdiPhone" :size="45" class="icon-color" w="w-14" h="h-14"></BaseIcon>
                                    </div>
                                    <div class="w-full ml-4 lg:ml-0">
                                        <p class="text-xl lg:text-2xl lg:text-center font-semibold mb-2">Telefono</p>
                                        <p class="text-sm text-gray-800 lg:text-center">{{ confGlobal.value.COMPANY_PHONE_MOBILE }}</p>
                                        <p class="text-sm text-gray-800  lg:text-center">{{ confGlobal.value.COMPANY_PHONE }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-span-1">
                                <div class="flex flex-row lg:flex-col justify-center border border-gray-200 p-5 rounded-lg shadow-xl shadow-gray-400/10">
                                    <div class="flex justify-center lg:mb-3">
                                        <BaseIcon :path="mdiEmail" :size="45" class="icon-color" w="w-14" h="h-14"></BaseIcon>
                                    </div>
                                    <div class="w-full ml-4 lg:ml-0">
                                        <p class="text-xl lg:text-2xl lg:text-center font-semibold mb-2">Email</p>
                                        <p class="text-sm text-gray-800 lg:text-center">{{ confGlobal.value.COMPANY_MAIL }}</p>
                                        
                                    </div>
                                </div>
                            </div>

                            <div class="col-span-1 lg:col-span-2">
                                <div class="flex flex-row lg:flex-col justify-center border border-gray-200 p-5 rounded-lg shadow-xl shadow-gray-400/10">
                                    <div class="flex justify-center lg:mb-3">
                                        <BaseIcon :path="mdiMapMarker" :size="45" class="icon-color" w="w-14" h="h-14"></BaseIcon>
                                    </div>
                                    <div class="w-full ml-4 lg:ml-0">
                                        <p class="text-xl lg:text-2xl lg:text-center font-semibold mb-2">Dirección</p>
                                        <p class="text-sm text-gray-800 lg:text-center">{{ confGlobal.value.COMPANY_CONTACT_ADDRESS }}</p>
                                        <!-- <p class="text-sm text-gray-800 lg:text-center">Los Olivos, Lima - Perú</p> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-span-1 lg:col-span-2">
                        <div class="rounded-lg">
                            <!-- <GoogleMap :api-key="YOUR_GOOGLE_MAPS_API_KEY" class="w-full h-[450px] rounded-lg google-maps" :center="center" :zoom="16">
                                <MarkerCluster>
                                    <Marker v-for="(location, i) in locations" :options="{ position: location }" :key="i" />
                                </MarkerCluster>
                            </GoogleMap> -->
                            
                            <GoogleMap v-if="!helpers.isEmpty(confGlobal.value.UNENS_GOOGLEMAPS_LAT) && !helpers.isEmpty(confGlobal.value.UNENS_GOOGLEMAPS_LNG)" :api-key="YOUR_GOOGLE_MAPS_API_KEY" class="w-full h-[450px] rounded-lg google-maps" :center="{lat: (parseFloat(confGlobal.value.UNENS_GOOGLEMAPS_LAT)), lng: (parseFloat(confGlobal.value.UNENS_GOOGLEMAPS_LNG))}" :zoom="16">
                                <!-- <Polyline :options="flightPath" /> -->
                                <MarkerCluster>
                                    <Marker v-for="(location, i) in [{ lat: parseFloat(confGlobal.value.UNENS_GOOGLEMAPS_LAT), lng: parseFloat(confGlobal.value.UNENS_GOOGLEMAPS_LNG) }]" :options="{ position: location }" :key="i" />
                                </MarkerCluster>
                            </GoogleMap>

                        </div>

                    </div>
                </div>
            </div>
        </section>

        <!-- END AREA DE CONTACTO -->
        <!-- END AREA DE CONTACTO -->
        <!-- END AREA DE CONTACTO -->

        <!-- <div class=" mx-auto px-4 sm:px-6 lg:px-8 py-12">
            <div class="grid grid-cols-2">
                <div class="col-span-1">
                    <Splide id="main-carousel" :options="{
                        type: 'fade',
                        rewind: true,
                        pagination: false,
                        arrows: false,
                    }">
                        <SplideSlide>
                            <img src="/img/productos/independiente/01.jpg" alt="Sample 1">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/02.jpg" alt="Sample 2">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/03.jpg" alt="Sample 2">
                        </SplideSlide>
                    </Splide>

                    <Splide :options="{
                        fixedWidth: 100,
                        fixedHeight: 60,
                        gap: 10,
                        rewind: true,
                        pagination: false,
                        cover: true,
                        focus: 'center',
                        breakpoints: {
                            600: {
                                fixedWidth: 60,
                                fixedHeight: 44,
                            },
                        },
                    }">
                        <SplideSlide>
                            <img src="/img/productos/independiente/01.jpg" alt="Sample 1">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/02.jpg" alt="Sample 2">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/03.jpg" alt="Sample 2">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/04.jpg" alt="Sample 2">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/05.jpg" alt="Sample 2">
                        </SplideSlide>
                    </Splide>
                </div>
            </div>

        </div> -->


    </BreezeGuestLayout>
</template>

<style scoped>
.splide__slide img {

    object-fit: cover;
}
</style>
